<template>
  <v-app v-if="!loading">
    <!-- CSS only -->
    <notifications classes="vue-notification bm-notification" group="app" position="top right"
                   style="width: auto; margin-top: 70px;"></notifications>
    <v-snackbar
      v-if="snackbarObj"
      :color="snackbarObj.color"
      :timeout="3000"
      :value="snackbarObj"
      top
    >{{ snackbarObj.message }}
    </v-snackbar>
    <v-navigation-drawer v-if="!presentationMode"
                         :clipped="false"
                         :disable-resize-watcher="true"
                         :disable-route-watcher="true"
                         :mini-variant="!fullMenu"
                         :permanent="fullMenu && authenticated"
                         :value="authenticated"
                         :width="265"
                         app
                         fixed
                         stateless
                         touchless
    >
      <v-toolbar class="transparent sidebar" flat>
        <v-list class="pa-0">
          <v-list-tile avatar>
            <v-list-tile-content class="sidebar-logo pt-3">
              <router-link :to="{name: 'home'}" style="width: 100%;text-align: center;">
                <img alt="W+K Benchmarking" src="@/assets/logo.png">
              </router-link>

            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list v-for="group in groups" v-if="group.items.filter(item => hasAnyRole(item.roles)).length > 0"
              :key="group.title"
              class="pa-0 mt-3">
        <v-subheader>{{ group.title }}</v-subheader>

        <v-list-tile
          v-for="(item, i) in group.items"
          v-if="!item.roles || hasAnyRole(item.roles) && !item.href.startsWith('http')"
          :key="i"
          :class="$route.path.startsWith(item.href) ? 'highlighted' : ''"
          value="true"
          @click="$router.push(item.href)"
        >

          <v-tooltip :disabled="fullMenu" right>
            <v-list-tile-action slot="activator">
              <v-icon v-html="item.icon"></v-icon>
            </v-list-tile-action>
            <span>{{ item.title }}</span>
          </v-tooltip>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-for="(item, i) in group.items"
          v-if="!item.roles || hasAnyRole(item.roles) && item.href.startsWith('http')"
          :key="i"
          :class="$route.path.startsWith(item.href) ? 'highlighted' : ''"
          :href="item.href"
          target='_blank'
          value="true"
          @click=""
        >

          <v-tooltip :disabled="fullMenu" right>
            <v-list-tile-action slot="activator">
              <v-icon v-html="item.icon"></v-icon>
            </v-list-tile-action>
            <span>{{ item.title }}</span>
          </v-tooltip>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list>
        <v-divider class="mt-3"></v-divider>
        <v-list-tile value="true" @click="logout">
          <v-tooltip :disabled="!fullMenu" right>
            <v-list-tile-action slot="activator">
              <v-icon v-html="'keyboard_arrow_left'"></v-icon>
            </v-list-tile-action>
            <span>Logout</span>
          </v-tooltip>
          <v-list-tile-content>
            <v-list-tile-title v-text="'Logout'"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      v-if="authenticated && !presentationMode"
      app
      color="primary"
      dark
    >
      <v-btn icon @click.stop="fullMenu = !fullMenu">
        <v-icon v-html="'menu'"></v-icon>
      </v-btn>
      <v-toolbar-title></v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content class="content">
      <router-view class="px-4 py-4"/>
    </v-content>
    <footer>
      <div v-if="!this.authenticated" id="footer">
        <div class="frame frame-default frame-type-multicolumn frame-layout-0">
          <ul class="multicolumnContainer multicolumnLayout2 clearfix " style="width: 100%;">
            <li class="column column1 columnFirst listItemFirst " style="width: 285px; ">
              <div class="columnItems" style="padding: 0 6px 0 0">
                <div
                  class="columnItem columnItem1 columnItemFirst listItemFirst columnItemLast listItemLast columnItemtext">
                  <div id="c590" class="frame frame-default frame-type-text frame-layout-0">
                    <p>WEIGERT + KUNDE<br> Unternehmensberatung GmbH<br> Dresdner Straße 44 ∙ 92318 Neumarkt i.d.OPf.
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li class="column column2 " style="width: 185px; ">
              <div class="columnItems" style="padding: 0 6px">
                <div
                  class="columnItem columnItem1 columnItemFirst listItemFirst columnItemLast listItemLast columnItemtext">
                  <div id="c591" class="frame frame-default frame-type-text frame-layout-0">
                    <p>info@weigertkunde.de<br> www.weigertkunde.de<br> Telefon: 0 91 81 / 48 53 - 0</p>
                  </div>
                </div>
              </div>
            </li>
            <li class="column column3 columnLast listItemLast" style="width: 177px; ">
              <div class="columnItems" style="padding: 0 0 0 6px">
                <div class="columnItem columnItem2 columnItemLast listItemLast columnItemtext">
                  <div>
                    <a class="internal-link" href="https://www.weigertkunde.de/impressum" target="_self"
                       title="Impressum">IMPRESSUM</a>
                    <a class="internal-link" href="https://www.weigertkunde.de/anfahrt" target="_self"
                       title="So gelangen Sie zu uns">ANFAHRT</a>
                    <a class="internal-link" href="https://www.weigertkunde.de/datenschutz" target="_self"
                       title="Datenschutz">DATENSCHUTZ</a>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <cookie-law theme="digi-bm">
        <div slot-scope="props">
          <h3>Cookie Einstellungen</h3>

          <div class="cookie-panel__description">
            Auf unserer Website verwenden wir Cookies. Einige davon sind für
            den Betrieb der Website essentiell notwendig, andere wiederum helfen uns dabei, diese
            Website und Ihre User Experience zu verbessern.
          </div>
          <div class="cookie-panel__control">
            <button class="all" @click="props.accept"><span>Nur essentielle Cookies akzeptieren</span></button>
            <button class="min" @click="props.close"><span>Speichern und schließen</span></button>

          </div>
          <div class="cookie-panel__link">
            <a href="https://www.weigertkunde.de/datenschutz" target="_self">Mehr über die genutzten Cookies
              erfahren</a>
          </div>
        </div>

      </cookie-law>
    </footer>
  </v-app>

</template>

<script>
import {mapGetters, mapState} from 'vuex'
import {Session} from '@/common/Session'
import UserService from '@/common/UserService'
import CookieLaw from 'vue-cookie-law'

export default {
  data() {
    return {
      fullMenu: true,
      title: '',
      loading: true
    }
  },
  components: {CookieLaw},
  methods: {
    logout() {
      Session.logout()
      this.$router.push('/login')
    },
  },
  mounted() {
    let bootstrapScript = document.createElement('script')
    bootstrapScript.setAttribute('src', '/static/bootstrap.bundle.min.js')
    document.head.appendChild(bootstrapScript)
  },


  created() {
    console.log(this.authenticated);
    // ensure we dont sth without possible session loaded and verified
    Session.getSession().then(() => {
      this.loading = false
    })
  },

  computed: {
    ...mapGetters([
      'authenticated',
      'analysisTypes',
    ]),
    ...mapState({
      snackbarObj: state => state.Global.snackbarObj,
      presentationMode: state => state.Global.presentationMode
    }),

    continuousRecordingAnalysisTypesMenuItems() {
      const navItems = this.analysisTypes.map(item => ({
        title: `${item.title}`,
        href: this.hasAnyRole(['ROLE_ADMIN'])
          ? `/analysis-types/${item.id}/admin/recordings`
          : `/analysis-types/${item.id}/my/recordings`,
        icon: 'fas fa-database',
        roles: ['ROLE_USER', 'ROLE_ADMIN']
      }));

      if (this.hasAnyRole(['ROLE_ADMIN'])
        || this.analysisTypes.find(item => item.id === '00000000-0000-0000-0000-000000000001') !== undefined) {
        navItems.push({
          title: 'Jahresplanung',
          href: this.hasAnyRole(['ROLE_ADMIN'])
            ? '/analysis-types/00000000-0000-0000-0000-000000000001/admin/plannings'
            : '/analysis-types/00000000-0000-0000-0000-000000000001/my/plannings',
          icon: 'fas fa-database',
          roles: ['ROLE_USER', 'ROLE_ADMIN']
        });
      }

      return navItems;
    },
    hasAnyRole() {
      return roles => this.$store.state.Session.session && UserService.hasAnyRole(roles, false)
    },
    groups() {
      return [
        {
          title: 'Benchmarking',
          items: [
            {
              icon: 'fas fa-user-chart',
              title: 'Workshops',
              href: this.hasAnyRole(['ROLE_ADMIN'])
                ? '/workshops'
                : '/my-workshops',
              roles: ['ROLE_USER', 'ROLE_ADMIN']
            },
            {
              icon: 'fas fa-receipt',
              title: 'Meine Maßnahmen',
              href: '/maßnahmenuebersicht',
              roles: ['ROLE_USER']
            },
            {
              icon: 'fas fa-users',
              title: 'Teilnehmerliste',
              href: '/teilnehmerliste',
              roles: ['ROLE_USER']
            },
            {
              icon: 'fas fa-chart-line',
              title: 'Entwicklung',
              href: this.hasAnyRole(['ROLE_ADMIN'])
                ? '/bm-development'
                : '/my-development-chart',
              roles: ['ROLE_USER', 'ROLE_ADMIN']
            }
          ],
        },
        {
          title: 'Datenpool',
          items: [
            {
              title: this.hasAnyRole(['ROLE_ADMIN']) ? 'Explorer' : 'Dateiupload',
              href: '/datenpool/explorer',
              icon: 'fas fa-folder-tree',
              roles: ['ROLE_USER', 'ROLE_ADMIN']
            },
            {
              title: 'Zugriffshistorie',
              href: '/datenpool/accesses',
              icon: 'fas fa-lock',
              roles: ['ROLE_ADMIN']
            },
            {
              title: 'Kategorien',
              href: '/datenpool/categories',
              icon: 'fas fa-folder',
              roles: ['ROLE_ADMIN']
            },
            {
              title: 'Schlagwörter',
              href: '/datenpool/tags',
              icon: 'fas fa-bookmark',
              roles: ['ROLE_ADMIN']
            }
          ],
        },
        {
          title: 'Datenerfassung / Planung',
          items: this.continuousRecordingAnalysisTypesMenuItems
        },
        {
          title: 'System / Stammdaten',
          items: [
            {
              title: 'Kanzleien',
              href: '/benchmarking-objects',
              icon: 'fas fa-building',
              roles: ['ROLE_ADMIN'],
            },
            {
              title: 'BM Gruppen',
              href: '/benchmarking-groups',
              icon: 'fas fa-users-class',
              roles: ['ROLE_ADMIN'],
            },
            {
              title: 'Controlling-Status / Analysen',
              href: '/analysis-types',
              icon: 'fas fa-analytics',
              roles: ['ROLE_ADMIN'],
            },
            {
              title: 'Themenpool',
              href: '/agenda-topics',
              icon: 'fas fa-list',
              roles: ['ROLE_ADMIN'],
            },
            {
              icon: 'fas fa-users',
              title: 'Übersicht aller Benutzer',
              href: '/users',
              roles: ['ROLE_ADMIN'],
            },
          ],
        },
        {
          title: 'Account und Sicherheit',
          items: [
            {
              icon: 'account_circle',
              title: 'Persönliche Daten',
              href: '/users/me',
              roles: ['ROLE_USER'],
            },
            {
              icon: 'settings',
              title: 'Passwort ändern',
              href: '/users/me/change-password',
              roles: ['ROLE_USER'],
            },
            {
              icon: 'security',
              title: '2FA',
              href: '/users/me/twofactor',
              roles: ['ROLE_USER', 'ROLE_ADMIN'],
            }
          ]
        },
        {
          title: 'Rechtliche Informationen',
          items: [
            {
              icon: 'info',
              title: 'AGB',
              href: 'https://www.weigertkunde.de/agb',
              roles: ['ROLE_USER'],
            },
            {
              icon: 'info',
              title: 'Verarbeitung pers.bez. Daten',
              href: 'https://www.weigertkunde.de/datenschutz',
              roles: ['ROLE_USER'],
            },
            {
              icon: 'info',
              title: 'Impressum',
              href: 'https://www.weigertkunde.de/impressum',
              roles: ['ROLE_USER'],
            },
            {
              icon: 'security',
              title: 'Datenschutz',
              href: 'https://www.weigertkunde.de/datenschutz',
              roles: ['ROLE_USER'],
            },
            {
              icon: 'account_circle',
              title: 'Kontakt',
              href: 'https://www.weigertkunde.de/kontakt',
              roles: ['ROLE_USER'],
            }
          ]
        }
      ]
    }
  },
  name: 'App'
}
</script>

<style lang="scss">

.headcol {
  position: sticky;
  width: 200px;
  left: 0px;
  z-index: 1;
  background-color: white;
}

.stickyButton {
  position: fixed;
  z-index: 1000;
  display: block;
  -webkit-backface-visibility: hidden;
  top: 10px;
  opacity: 1;
  -webkit-transition: background .2s ease;
  transition: background .2s ease;
}

.bm-notification {
  margin: 5px 30px 5px 0;

  .notification-title {
    font-size: 18px;
    padding-left: 20px;
    padding-right: 40px;
  }

  .notification-content {
    font-size: 18px;
    padding-left: 20px;
    padding-right: 40px;
  }
}

main.v-content {

}

.sidebar-logo {

}

.v-list__tile {
  height: 42px;
}

.v-subheader {
  height: 20px;
}

.sidebar-logo img {
  width: 60%;
  margin: 0 auto;
}

.application .theme--light.v-icon, .theme--light .v-icon {
  color: #444444;
}

.theme--light .accent--text {
  color: #4caf50 !important;
  caret-color: #4caf50 !important;
}

.application .theme--light.v-subheader, .theme--light .v-subheader {

}

.v-list__tile__title {
  color: #444444 !important;
}

.v-list__tile--avatar {
  height: 117px;
}

.sidebar .v-toolbar__content {
  height: 117px !important;
}

.application .theme--dark.v-toolbar, .theme--dark .v-toolbar {
  background-color: #212121 !important;
  color: #fff;
}

.theme--light .v-card .v-toolbar {
  background-color: white !important;
  border-top: 10px solid #1855ef;
  color: #444444;
  box-shadow: none;
}

.v-content {
  background: #f5f3f3;
}

.v-input__slot {
  border-width: 1px !important;
}

/*
.v-input, .v-textarea {
  background: white;
}
 */

.v-chip .v-chip__content {
  height: 22px;
}

td .v-btn--icon {
  width: 30px;
}

td .v-btn {
  height: 30px;
}

table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
  padding: 0 12px;
}

table.v-table tbody td, table.v-table tbody th {
  height: 38px;
}

table.v-table tbody td, table.v-table tbody th {
  margin: 0px;
}

.v-tabs__div {
  text-transform: none;
}

</style>

<style lang="scss" scoped>
.v-list__tile__action .v-icon {
  font-size: 20px;
}

.v-list__tile__action {
  min-width: 44px;
}

.highlighted {
  background: #d4dbed4f;
}

.Cookie {
  display: block;
}

.Cookie--digi-bm {
  margin: auto;
  width: 75vw;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.7);
  border-bottom: none;
  padding: 16px;
  font-family: 'MavenPro', sans-serif;
  font-size: 13px;
  color: #767676;
  text-align: center;
}

.Cookie--digi-bm h3 {
  margin: 16px 0;
  margin-top: 0px;
  color: #1f5799;
  font-size: 16px;
  text-transform: uppercase;
  line-height: 1.5em;
  font-weight: 600;
  border: none;
  text-align: left;
}

.Cookie--digi-bm div.cookie-panel__description {
  font-size: 13px;
  color: #767676;
  text-align: center;
}

.Cookie--digi-bm div.cookie-panel__control button.all {
  background-color: #1f5799;
  border: 2px solid #1f5799;
  color: #fff;
  border-radius: 0;
  margin: 0;
  margin-right: 1px;
  margin-bottom: 4px;
  padding: 4px 16px;
  font-family: 'MavenPro', sans-serif;
  font-weight: 600;
  text-transform: initial;
  letter-spacing: 0.5px;
}

.Cookie--digi-bm div.cookie-panel__control button.min,
.Cookie--digi-bm div.cookie-panel__control button.close {
  background-color: #e4eaf8;
  border: 2px solid #e4eaf8;
  color: #5D7EB2;
  border-radius: 0;
  margin: 0;
  margin-right: 1px;
  margin-bottom: 4px;
  padding: 4px 16px;
  font-family: 'MavenPro', sans-serif;
  font-weight: 600;
  text-transform: initial;
  letter-spacing: 0.5px;
}

.Cookie--digi-bm div.cookie-panel__control {
  text-align: center;
}

.Cookie--digi-bm div.cookie-panel__link,
.Cookie--digi-bm div.cookie-panel__control {
  padding-top: 1em;
}

.Cookie--digi-bm div.cookie-panel__link a {
  color: #5D7EB2;
}

.Cookie--digi-bm div.Cookie__button:hover {

}

#footer {
  margin: -100px auto;
  position: relative;
}

#footer .column {
  float: left;
  padding-top: 5px;
}

#footer .column3 {
  margin-left: 10px;
}

#footer ul li {
  list-style-type: none;
}

#footer {
  width: 700px;
  padding: 0px;
  padding-bottom: 20px;
  color: #878787;
  text-align: left;
  text-decoration: none;
  font-size: 13px;
}

#footer * {
  color: #C7C7C7;
  text-decoration: none;
}

#footer h1 {
  margin-bottom: 12px;
  font-size: 32px;
}

#footer h1 i {
  color: #D1D1D1;
}

#footer p {
  padding: 0;
}

#footer a {
  font-size: 15px;
  margin-bottom: 6px;
  display: inline-block;
}

#footer .column3 a {
  font-size: 11px;
  display: block;
}

#footer a:hover {
  color: #c9c9c9;

}

#footer a i {
  font-size: 1.5em;
}


#footer .multicolumnContainer {
  margin: 0 auto;
}

#footer .multicolumnContainer li {
  border-top: 2px solid #F6F8FE;
}

</style>



// WEBPACK FOOTER //
// src/App.vue